import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';

const AiServiceLayout = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();

  const navItems = [
    {
      href: PATH_PAGE.dashboard.ai.overview(orgId, workspaceId),
      label: 'Services',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.ai.credentials(orgId, workspaceId),
      label: 'API Key',
      strictMatch: true,
    },
  ];

  const navbarConfig = useMemo(
    () => ({
      title: 'AI Module',
      navbar: navItems,
    }),
    [workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <>
      <Outlet />
    </>
  );
};

export default AiServiceLayout;
